export class Portfolio {
  portfolioId: string = '';
  personId: string = '';
  portfolio: string = '';
  attachment: string = '';
  lastUpdate: string = '';
  attachmentLink: string = '';
  attachmentUrl: string = '';
  validTitle: string = '';
  fileErrorMsg: string = '';
}